<template>
  <div class="ps-wrap">
    <div class="ps-outer" :style="{ maxWidth: maxWidth }">
      <div class="ps-card">
        <div class="ps-accent"></div>

        <div class="ps-head">
          <div class="ps-logo">
            <img v-if="igreja && igreja.logoUrl" :src="igreja.logoUrl" alt="logo" />
            <div v-else class="ps-logo-fallback">{{ (igreja && igreja.nome) || 'Templus' }}</div>
          </div>
          <h1 v-if="titulo" class="ps-title">{{ titulo }}</h1>
          <p v-if="igreja && igreja.nome" class="ps-sub">{{ igreja.nome }}</p>
        </div>

        <div v-if="valido" class="ps-body">
          <slot />
        </div>
        <div v-else class="ps-invalid">
          <v-icon size="52" color="#EF5350">mdi-link-off</v-icon>
          <p>Link inválido. Solicite o link correto à sua igreja.</p>
        </div>
      </div>

      <div class="ps-footer">
        <a href="https://www.intelitetecnologia.com.br/" target="_blank">
          <img src="../assets/logoTemplusIntelite.png" alt="Templus · Intelite" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicShell',
  props: {
    igreja: { type: Object, default: () => ({}) },
    titulo: { type: String, default: '' },
    valido: { type: Boolean, default: true },
    maxWidth: { type: String, default: '560px' },
  },
  // Páginas públicas são sempre claras (card branco). Se o usuário estiver com o
  // tema escuro do ambiente logado, os inputs Vuetify herdariam .theme--dark e
  // quebrariam sobre o card branco. Forçamos o tema claro enquanto o shell está
  // montado e restauramos ao sair (caso a navegação seja na mesma aba).
  created() {
    this._temaAnterior = this.$vuetify.theme.dark
    this.$vuetify.theme.dark = false
  },
  beforeDestroy() {
    if (typeof this._temaAnterior === 'boolean') this.$vuetify.theme.dark = this._temaAnterior
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,600;9..144,700&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

.ps-wrap {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 16px;
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background:
    radial-gradient(900px 520px at 88% -8%, rgba(255,255,255,.18), transparent 60%),
    linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
}
.ps-outer { width: 100%; }

.ps-card {
  position: relative;
  background: #fff;
  border-radius: 20px;
  padding: 30px 30px 26px;
  box-shadow: 0 30px 70px rgba(0, 37, 62, .28);
  overflow: hidden;
}
.ps-accent {
  position: absolute; top: 0; left: 0; right: 0; height: 5px;
  background: linear-gradient(90deg, #5BC1A3, #01B094, #00695C);
}

.ps-head { text-align: center; margin-bottom: 22px; }
.ps-logo { margin-bottom: 12px; }
.ps-logo img { max-height: 96px; max-width: 72%; object-fit: contain; }
.ps-logo-fallback {
  font-family: 'Fraunces', Georgia, serif; font-weight: 700; font-size: 1.5rem;
  color: #16322E; padding: 6px 0;
}
.ps-title {
  font-family: 'Fraunces', Georgia, serif; font-weight: 600; font-size: 1.55rem;
  color: #16322E; margin: 0; letter-spacing: -0.01em; line-height: 1.15;
}
.ps-sub { color: #5b6b67; font-size: .95rem; margin: 4px 0 0; }

.ps-body { margin-top: 4px; }

.ps-invalid { text-align: center; padding: 26px 10px 14px; }
.ps-invalid p { color: #5b6b67; font-weight: 600; margin: 12px 0 0; }

.ps-footer { text-align: center; margin-top: 18px; }
.ps-footer img { width: 220px; max-width: 70%; opacity: .95; }

@media (max-width: 600px) {
  .ps-card { padding: 24px 18px 20px; }
  .ps-title { font-size: 1.35rem; }
}
</style>
